'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaveOffer = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveOffer = function (_Component) {
  (0, _inherits3.default)(SaveOffer, _Component);

  function SaveOffer() {
    (0, _classCallCheck3.default)(this, SaveOffer);
    return (0, _possibleConstructorReturn3.default)(this, (SaveOffer.__proto__ || (0, _getPrototypeOf2.default)(SaveOffer)).apply(this, arguments));
  }

  (0, _createClass3.default)(SaveOffer, [{
    key: 'getPrice',
    value: function getPrice() {
      var _props = this.props,
          price = _props.price,
          currencyCode = _props.currencyCode;


      return _react2.default.createElement(_reactIntl.FormattedNumber, {
        style: 'currency',
        value: price,
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }
  }, {
    key: 'renderPlanName',
    value: function renderPlanName() {
      var credits = this.props.credits;


      return _react2.default.createElement(
        'strong',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'save.offer.accepted.plan',
          defaultMessage: '{credits} credit/mo.',
          values: {
            credits: credits,
            price: this.getPrice()
          }
        })
      );
    }
  }, {
    key: 'renderSaveOfferSuccess',
    value: function renderSaveOfferSuccess() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'modal__header modal__header__img p++' },
          _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'save.offer.accepted.header',
              defaultMessage: 'You\u2019re Good to Go!'
            })
          )
        ),
        _react2.default.createElement(
          'p',
          { className: 'm+' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'save.offer.accepted.details',
            defaultMessage: 'Your membership change is confirmed, and your new {plan} plan will begin at the start of your next cycle.',
            values: {
              plan: this.renderPlanName()
            }
          })
        ),
        _react2.default.createElement(
          'p',
          { className: 'text--center mb+' },
          _react2.default.createElement(
            'a',
            { href: '/classes', className: 'bt bt--primary bt--solid bt--lg bt--width-lg', target: '_self' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'save.offer.accepted.book.class',
              defaultMessage: 'Book a Class'
            })
          )
        )
      );
    }
  }, {
    key: 'renderSaveOffer',
    value: function renderSaveOffer() {
      var _props2 = this.props,
          credits = _props2.credits,
          loading = _props2.loading,
          name = _props2.name,
          onAccept = _props2.onAccept,
          rolloverCredits = _props2.rolloverCredits;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'modal__header modal__header__img p++' },
          _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'save.offer.header',
              defaultMessage: 'Looking for a better fit, {name}?',
              values: {
                name: name
              }
            })
          )
        ),
        _react2.default.createElement(
          'p',
          { className: 'm+' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'save.offer.details',
            defaultMessage: 'Our {plan} plan might work better for your schedule. Enjoy the same great ClassPass benefits you\u2019re used to: access to thousands of classes in any of our cities.',
            values: {
              plan: this.renderPlanName()
            }
          })
        ),
        _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)('bt bt--primary bt--lg mb+', {
              'bt--waiting': loading
            }),
            onClick: onAccept
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'save.offer.accept',
            defaultMessage: 'Yes, I want {credits} credits for {price}',
            values: {
              credits: credits,
              price: this.getPrice()
            }
          })
        ),
        _react2.default.createElement(
          'a',
          {
            className: 'link--stealth text--small block mb+',
            href: '/settings/membership/update',
            target: '_self'
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'save.offer.dismiss',
            defaultMessage: 'I\u2019d rather cancel or take a break'
          })
        ),
        _react2.default.createElement(
          'p',
          { className: 'text--sm text--light m+' },
          _react2.default.createElement(
            'em',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'save.offer.fine.print',
              defaultMessage: 'Your {credits}\u200C credit/mo. plan for {price}\u200C begins at the start of your next billing cycle. Up to {rolloverCredits} credits will roll over automatically to your next month. You will automatically be charged each month for your new plan until you cancel, which you can do on the site at any time. By confirming your plan change, you agree to the ClassPass {terms} and {privacy}.',
              values: {
                credits: credits,
                rolloverCredits: rolloverCredits,
                price: this.getPrice(),
                privacy: _react2.default.createElement(
                  'a',
                  { href: '/privacy' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'save.offer.fine.print.privacy',
                    defaultMessage: 'Privacy Policy'
                  })
                ),
                terms: _react2.default.createElement(
                  'a',
                  { href: '/terms' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'save.offer.fine.print.terms',
                    defaultMessage: 'Terms of Use'
                  })
                )
              }
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var planChangeSuccessful = this.props.planChangeSuccessful;


      var offer = this.renderSaveOffer();

      if (planChangeSuccessful) {
        offer = this.renderSaveOfferSuccess();
      }

      return offer;
    }
  }]);
  return SaveOffer;
}(_react.Component);

SaveOffer.propTypes = {
  credits: _propTypes2.default.number.isRequired,
  currencyCode: _propTypes2.default.string.isRequired,
  loading: _propTypes2.default.bool,
  planChangeSuccessful: _propTypes2.default.bool,
  price: _propTypes2.default.number.isRequired,
  rolloverCredits: _propTypes2.default.number.isRequired,
  name: _propTypes2.default.string.isRequired,
  onAccept: _propTypes2.default.func.isRequired
};

exports.SaveOffer = SaveOffer;